import React, { useState } from 'react';
import './DonationAlert.css';

const DonationAlert = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="donation-alert">
      <button className="close-button" onClick={handleClose} aria-label="Fechar">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <h3>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
          <path d="M2 17l10 5 10-5"></path>
          <path d="M2 12l10 5 10-5"></path>
        </svg>
        Ajude o Projeto a Crescer
      </h3>
      <p>Sua doação ajuda a manter o servidor online e a trazer novas atualizações para todos os jogadores!</p>
      <a href="#doacao" className="donate-button">
        Fazer uma Doação PIX
      </a>
    </div>
  );
};

export default DonationAlert;
